//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios';

import {
  faCopy,
  faArrowsRotate,
  faTrash,
  faPaperPlaneTop,
  faBriefcase,
  faSmile,
  faLightbulb,
  faGraduationCap,
  faChessQueen,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faExternalLinkAlt,
} from '@fortawesome/pro-light-svg-icons';
import {
  maxLength,
  minLength,
} from 'vuelidate/lib/validators';

import { publishedContentCounts, renderContentCount } from '@motionelements/core/src/helpers/contentCount.js';
import api from '@motionelements/core/src/api/base-api-v2.js';

export default {
  name: 'ai-scriptwriter',
  layout: 'minimal',
  components: {
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    HomeFaqs: () => import('@/components/home-page/HomeFaqs.vue'),
    BaseBreadcrumbs: () => import('@/components/core/BaseBreadcrumbs.vue'),
    ButtonLadda: () => import('@motionelements/core/src/components/ui/BaseButtonLadda.vue'),
    BaseInputText: () => import('@motionelements/core/src/components/ui/form/BaseInputText.vue'),
  },
  head() {
    return {
      meta: [
        {
          name: '_foundr', // https://foundr.ai
          content: 'c0477ab43b13bb1fde31872a230260ef',
        },
      ],
    };
  },
  data() {
    return {
      icons: {
        faCopy,
        faArrowsRotate,
        faTrash,
        faPaperPlaneTop,
      },
      isValid: null,
      maxDuration: 300,
      // maxDuration: 60,
      minDuration: 10,
      generatedHtml: '',
      isLoading: false,
      isStreaming: false,
      toneOfVoices: [
        {
          id: 'professional',
          title: this.$t('ai_scriptwriter.tone.professional'),
          icon: faBriefcase,
        },
        {
          id: 'friendly',
          title: this.$t('ai_scriptwriter.tone.friendly'),
          icon: faSmile,
        },
        {
          id: 'inspirational',
          title: this.$t('ai_scriptwriter.tone.inspirational'),
          icon: faLightbulb,
        },
        {
          id: 'educational',
          title: this.$t('ai_scriptwriter.tone.educational'),
          icon: faGraduationCap,
        },
        {
          id: 'authoritative',
          title: this.$t('ai_scriptwriter.tone.authoritative'),
          icon: faChessQueen,
        },
      ],
      form: {
        prompt: '',
        tone: 'friendly',
        duration: 10,
      },
      combineSplitData: '',
      combineLink: '',
      loadingLink: false,
    };
  },
  validations: {
    form: {
      prompt: {
        minLength: minLength(10),
        maxLength: maxLength(1000),
      },
    },
  },
  computed: {
    examplePrompt() {
      return this.$t('ai_scriptwriter.example_prompt');
    },
    externalIcon() {
      const icon = faExternalLinkAlt.icon;
      return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${icon[0]} ${icon[1]}" class="svg-inline--fa ml-1"><path fill="currentColor" d="${icon[4]}"></path></svg>`;
    },
    generatedHtmlWithLinks() {
      // pattern to transform string with [$linkText]($linkUrl) into html link
      const pattern = /\[([^\]]+)\]\(([^)]+)\)/g;

      return this.generatedHtml.replace(pattern, `[<a href="$2" target="_blank">$1 ${this.externalIcon}</a> ]`);
    },
    pageTitle() {
      return this.$t('nav.ai_scriptwriter');
    },
    pageDescription() {
      return this.$t('ai_scriptwriter.page_text_1');
    },
    totalContentCount() {
      return renderContentCount(this, publishedContentCounts.total.element);
    },
    showCopyButton() {
      return false;
    },
    breadcrumbList() {
      return [
        {
          name: this.$t('ai_scriptwriter.page_breadcrumb'),
          link: this.$link('/ai-video').fullPath(),
          active: true,
        },
      ];
    },
  },
  methods: {
    setExamplePrompt() {
      this.form.prompt = this.examplePrompt;
      this.$scrollTo('#prompt-input');
      this.generateAiScript();
    },
    validateDurationInput(event) {
      const value = +event.target.value;
      if (value > this.maxDuration) {
        event.target.value = this.maxDuration;
        this.form.duration = this.maxDuration;
      } else if (value < this.minDuration) {
        event.target.value = this.minDuration;
        this.form.duration = this.minDuration;
      } else {
        this.form.duration = Math.round(value);
      }
    },
    removeSelection(e) {
      const value = e.target.value;
      if (value && value === this.form.tone) {
        this.form.tone = '';
      }
    },
    parseLink(value) {
      // if stream return link - add loading state with ... and set link to this.combineLink
      // first check of there is a link
      if (value.includes('(')) {
        this.loadingLink = true;
        this.combineLink += value;
        return false;
      }
      if (this.combineLink) {
        this.combineLink += value;
        // second check of there is a link
        if (!this.combineLink.includes('https')) {
          this.loadingLink = false;
          this.generatedHtml += this.combineLink;
          this.combineLink = '';
        }
        // after link is ended - add combineLink to generatedHtml and clear combineLink
        if (value.includes(')')) {
          this.loadingLink = false;
          this.generatedHtml += this.combineLink;
          this.generatedHtml += '<br><br>';
          this.combineLink = '';
        }
        return false;
      }

      return true;
    },
    parseValue(value) {
      try {
        const parsedValue = JSON.parse(value);
        const content = _.get(parsedValue, 'choices[0].delta.content', '');
        if (content && this.parseLink(content)) {
          if (this.generatedHtml && !this.generatedHtml.endsWith('<br><br>') && content.includes('[')) {
            this.generatedHtml += '<br><br>';
          }
          this.generatedHtml += content;
          if (content.includes(']') && !content.includes('](')) {
            this.generatedHtml += '<br><br>';
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    async generateAiScript() {
      if (!this.form.prompt) {
        this.$refs.prompt.$refs.input.focus();
        return;
      }

      this.$v.form.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;

      if (!this.$v.form.$invalid) {
        this.isLoading = true;
        this.generatedHtml = '';
        this.isStreaming = true;
        const baseUrl = (process.env.VUE_APP_ENV === 'production' ? process.env.VUE_APP_API_URL : 'https://stage.motionelements.com');
        await fetch(`${baseUrl}/v2/scripts/generate?${new URLSearchParams({
          ...api.getLocaleParams(),
          ...this.form,
        })}`, {
          method: 'GET',
          headers: {
            Accept: 'text/event-stream',
          },
        })
          .then(async response => {
            this.isLoading = false;

            console.log(response);

            const reader = response.body.getReader();

            // eslint-disable-next-line no-constant-condition
            while (true) {
              // eslint-disable-next-line no-await-in-loop
              const { done, value } = await reader.read();
              if (done) {
                console.log('done', done);
                break;
              }

              const decoderValue = new TextDecoder().decode(value);

              const decoderValueArr = decoderValue.split('data: ');

              decoderValueArr.filter(value => !!value).map(value => {
                if (value.includes('DONE')) {
                  return;
                }
                // if the previous response doesn't end with "}", combine the 2 responses to parse them
                if (this.combineSplitData) {
                  this.combineSplitData += value;
                  this.parseValue(this.combineSplitData);
                  // clear combineSplitData after parse
                  this.combineSplitData = '';
                  return;
                }
                // if the data does not end with "}", set it to combineSplitData and wait for the next response.
                if (value.trim().slice(-1) !== '}') {
                  this.combineSplitData += value;
                  return;
                }
                this.parseValue(value);
              });
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.isLoading = false;
            this.isStreaming = false;
          });
      }
    },
    clearForm() {
      this.form.prompt = '';
      this.form.tone = 'friendly';
      this.form.duration = 10;
      this.generatedHtml = '';
    },
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.generatedHtml);
      } catch ($e) {
        console.error($e);
      }
    },
  },
};
